import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const getIncomingApplications = createAsyncThunk(
  "getIncomingApplications",
  async (applicationStatus) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form?status=${applicationStatus}&stage=CONTRACTOR`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

// RC Extension API
export const getRcExtensionApplications = createAsyncThunk(
  "getRcExtensionApplications",
  async (applicationStatus) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form/scope-extension?status=${applicationStatus}&stage=CONTRACTOR`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

// RC Renewal API
export const getRcRenewalApplications = createAsyncThunk(
  "getRcRenewalApplications",
  async (applicationStatus) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form?status=${applicationStatus}&renewal=true&stage=CONTRACTOR`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getIncomingApplicationById = createAsyncThunk(
  "getIncomingApplicationById",
  async (applicationId) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form/${applicationId}`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getIncomingExApplicationById = createAsyncThunk(
  "getIncomingExApplicationById",
  async (applicationId) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form/scope-extension/${applicationId}`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getCountForAdmins = createAsyncThunk(
  "getCountForAdmins",
  async () => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form/agg-status/count`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

//"assign to me button action"
export const postAssignToMe = createAsyncThunk(
  "postAssignToMe",
  async ({ id, applicationRenewStatus }) => {
    console.log(applicationRenewStatus);
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const bearerToken = localStorage.getItem("cu_user");
        try {
          const baseUrl = process.env.REACT_APP_API_HOST;
          let url;
          if (applicationRenewStatus === "extension") {
            url = `${baseUrl}/api/cui-application-form/scope-extension/assign/${encodeURIComponent(
              id
            )}`;
          } else if (applicationRenewStatus === "renew") {
            url = `${baseUrl}/api/cui-application-form/renew/assign/${encodeURIComponent(
              id
            )}`;
          } else {
            url = `${process.env.REACT_APP_API_HOST}/api/cui-application-form/self-assign/${id}`;
          }
          let response;
          if (
            applicationRenewStatus === "extension" ||
            applicationRenewStatus === "renew"
          ) {
            response = await axios.post(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                },
              }
            );
          } else {
            response = await axios.patch(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                },
              }
            );
          }

          if (response?.data?.status === "success") {
            resolve(response);
            return response?.data;
          } else {
            const errorMsg =
              response?.data?.message || "Failed to assign application";
            reject(new Error(errorMsg));
          }
        } catch (error) {
          console.error("Assign error:", error);
          const errorMsg =
            error?.response?.data?.message ||
            error?.message ||
            "Error assigning application";
          reject(new Error(errorMsg));
        }
      }),
      {
        pending: "Assigning...",
        success: "Assigned to you successfully",
        error: {
          render({ data }) {
            return data?.message || "Failed to assign application";
          },
        },
      }
    );
  }
);

export const approveApplication = createAsyncThunk(
  "approveApplication",
  async ({ id, values, applicationRenewStatus }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const bearerToken = localStorage.getItem("cu_user");
        try {
          const baseUrl = process.env.REACT_APP_API_HOST;
          let url;
          if (applicationRenewStatus === "renew") {
            url = `${baseUrl}/api/cui-application-form/renew/approve/${encodeURIComponent(
              id
            )}`;
          } else if (applicationRenewStatus === "extension") {
            url =
              url = `${baseUrl}/api/cui-application-form/scope-extension/approve/${encodeURIComponent(
                id
              )}`;
          } else {
            url = `${baseUrl}/api/cui-application-form/approve/${encodeURIComponent(
              id
            )}`;
          }

          let res;
          if (
            applicationRenewStatus === "renew" ||
            applicationRenewStatus === "extension"
          ) {
            res = await axios.post(url, values, {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
              },
            });
          } else {
            res = await axios.patch(url, values, {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
              },
            });
          }

          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
          throw new Error("Error");
        }
      }),
      {
        pending: "Approving...",
        success: "Application approved successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const rejectApplication = createAsyncThunk(
  "approveApplication",
  async ({ id, applicationRenewStatus }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const bearerToken = localStorage.getItem("cu_user");
        try {
          let url;
          if (applicationRenewStatus === "extension") {
            url = `${
              process.env.REACT_APP_API_HOST
            }/api/cui-application-form/scope-extension/reject/${encodeURIComponent(
              id
            )}`;
          } else {
            url = `${process.env.REACT_APP_API_HOST}/api/cui-application-form/reject/${id}`;
          }
          let res;
          if (applicationRenewStatus === "extension") {
            res = await axios.post(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                },
              }
            );
          } else {
            res = await axios.patch(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${bearerToken}`,
                },
              }
            );
          }

          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "Application rejected successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const ContractorSlice = createSlice({
  name: "contractor",
  initialState: {
    incomingApplications: [],
    rcExtensionApplications: [],
    rcRenewalApplications: [],
    application: null,
    counts: [],
    status: "idle",
    isloading: true,
    error: null,
    exApplication: null,
  },
  reducers: {},
  extraReducers: {
    [getIncomingApplications.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getIncomingApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.incomingApplications = action.payload;
      state.isloading = false;
    },
    [getIncomingApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = false;
    },
    [getIncomingApplicationById.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getIncomingApplicationById.fulfilled]: (state, action) => {
      state.application = action.payload;
      state.status = "success";
      state.isloading = false;
    },
    [getIncomingApplicationById.rejected]: (state, action) => {
      state.error = action.error;
      state.status = "failed";
      state.isloading = false;
    },
    [getIncomingExApplicationById.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getIncomingExApplicationById.fulfilled]: (state, action) => {
      state.exApplication = action.payload;
      state.status = "success";
      state.isloading = false;
    },
    [getIncomingExApplicationById.rejected]: (state, action) => {
      state.error = action.error;
      state.status = "failed";
      state.isloading = false;
    },
    [getCountForAdmins.pending]: (state, action) => {
      state.status = "pending";
    },
    [getCountForAdmins.fulfilled]: (state, action) => {
      state.counts = action.payload;
      state.status = "success";
    },
    [getCountForAdmins.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
    [postAssignToMe.pending]: (state) => {
      state.status = "pending";
    },
    [postAssignToMe.fulfilled]: (state) => {
      state.status = "success";
    },
    [postAssignToMe.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
    [getRcExtensionApplications.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getRcExtensionApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.rcExtensionApplications = action.payload;
      state.isloading = false;
    },
    [getRcExtensionApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = false;
    },

    // RC Renewal
    [getRcRenewalApplications.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getRcRenewalApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.rcRenewalApplications = action.payload;
      state.isloading = false;
    },
    [getRcRenewalApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = false;
    },
  },
});

export default ContractorSlice.reducer;
